import React from 'react';
import BackButton from '../../components/BackButton';

import { Redux, Slices } from 'spwa-ui-library';
import { FormattedMessage, useIntl } from 'react-intl';
import { Grid, Button } from '@material-ui/core';
import css from '../Cart/CouponBox/index.module.scss';
import DrawerPwa from '../../components/DrawerPwa';
import DialogContent from '@material-ui/core/DialogContent';
import DialogBox from '../../components/DialogBox';
const { useSelector, useDispatch } = Redux;
const { selectDesktop } = Slices.appSlice;
export default function RenderTC({ goTocart, isTermsOpen, navigateToExplore, setIsTermsOpen }) {
  const intl = useIntl();
  const lang = intl.locale;
  const isDesktop = useSelector(selectDesktop);
  const cartData = useSelector((state) => state.cart);
  const getTncHTML = () => {
    const baseObj = cartData.data.promo || null;

    if (!baseObj) return '';
    // debugger;
    const tnc = baseObj[`tnc_${lang}`] || '';
    var parser = new DOMParser();
    var doc = parser.parseFromString(tnc, 'text/html');
    return doc.getElementsByTagName('body')[0].innerHTML;
  };
  const closeTerms = () => {
    setIsTermsOpen();
    // goTocart();
  };
  const renderTAndC = () => (
    <>
      {!isDesktop ? (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          open={isTermsOpen}
          className={css.drawer}
          onClose={closeTerms}
        >
          <div className={css.inner}>
            <div className={css.badge}>
              <div className={css.couponCode}>
                <FormattedMessage id="promo_code" defaultMessage="PROMO CODE" />:{' '}
                {cartData.data.promo.couponCode}
              </div>
            </div>
            <Grid className={css.termsContainer}>
              <div dangerouslySetInnerHTML={{ __html: getTncHTML() }}></div>
            </Grid>
          </div>
        </DrawerPwa>
      ) : (
        <>
          <DialogBox title="" size="sm" isOpen={isTermsOpen} onClose={closeTerms} page="login">
            <DialogContent dividers={true}>
              <div className={css.inner}>
                <div className={css.badge}>
                  <div className={css.couponCode}>
                    <FormattedMessage id="promo_code" defaultMessage="PROMO CODE" />:{' '}
                    {cartData.data.promo.couponCode}
                  </div>
                </div>
                <Grid className={css.termsContainer}>
                  <div dangerouslySetInnerHTML={{ __html: getTncHTML() }}></div>
                </Grid>
              </div>
            </DialogContent>
          </DialogBox>
        </>
      )}
    </>
  );
  return (
    <React.Fragment>
      {!isDesktop ? (
        <DrawerPwa
          hideCloseButton={true}
          variant="temporary"
          anchor="bottom"
          open={true}
          className={css.nobg}
          onClose={closeTerms}
        >
          {renderTAndC()}
        </DrawerPwa>
      ) : (
        <DialogBox size="sm" isOpen={true} onClose={closeTerms}>
          {renderTAndC()}
        </DialogBox>
      )}
    </React.Fragment>
  );
}
